import {useQuery} from "@tanstack/react-query";
import {getTopReferralsService} from "@/services/account/referral.service";

const ONE_HOUR = 1000 * 60 * 60;

const useGetTopReferrals = () => {
  const {data, isPending} = useQuery({
    queryKey: ["topReferrals"],
    queryFn: getTopReferralsService,
    staleTime: ONE_HOUR,
    gcTime: ONE_HOUR,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: 1,
  });

  return {
    referrers: data?.data?.data ?? [],
    isPending,
  };
};

export default useGetTopReferrals;
